<template>
  <v-menu
    v-model="menu"
    offset-y
    transition="slide-y-transition"
    origin="center center"
    rounded="lg"
    :nudge-bottom="20"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn text icon v-bind="attrs" v-on="on" class="ml-4">
        <v-icon>mdi-view-dashboard</v-icon>
      </v-btn>
    </template>

    <v-card width="800px" class="glass">
      <!-- <v-card-title class="text-subtitle-2">
        Pinned
      </v-card-title> -->

      <v-card-text style="height: 500px; overflow-y: auto;">
        <v-item-group>
          <v-container class="pl-6 pr-6">
            <v-subheader class="text-subtitle-2 text--primary mb-3"
              >Pinned</v-subheader
            >
            <v-row justify="start" no-gutters>
              <v-col align="center" sm="2" v-for="n in 15" :key="n">
                <!-- <v-item v-slot="{ active, toggle }"> -->
                <v-hover v-slot="{ hover }">
                  <v-card
                    style="height: 100px"
                    flat
                    color="transparent"
                    :elevation="hover ? 1 : 0"
                    :class="{ 'on-hover': hover }"
                    @click=""
                  >
                    <v-card-text
                      class="pa-0 fill-height d-flex justify-center align-center"
                    >
                      <div>
                        <div>
                          <v-icon large>mdi-account</v-icon>
                        </div>
                        <div>Cadastro de Clientes</div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-hover>
                <!-- </v-item> -->
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn text @click="menu = false">
          Cancel
        </v-btn>
        <v-btn color="primary" text @click="setDarkTheme">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "WindowMenu",

  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
  }),

  methods: {
    setDarkTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
  },
};
</script>

<style lang="scss" scoped>
.glass {
  background: rgba(255, 255, 255, 0.1) !important;
  // background: linear-gradient(
  //   to right bottom,
  //   rgba(255, 255, 255, 0.5),
  //   rgba(255, 255, 255, 0.1)
  // ) !important;
  /* border-radius: 2rem !important; */
  z-index: 19;
  backdrop-filter: blur(1rem) !important;
}

.v-menu__content {
  backdrop-filter: blur(1rem) !important;
}
</style>
